// extracted by mini-css-extract-plugin
export default {"container":"PdfViewer_container__dGN+v","loaderWrap":"PdfViewer_loaderWrap__3gh1F","pdfViewerModal":"PdfViewer_pdfViewerModal__DrlpO","page":"PdfViewer_page__p1Sf3"};